
import React from 'react'
import './index.less'
console.log(React)
export default function TopImage(props) {
  let src = null
  let item = null

  if (props.ifon.ad_location === 'sns') {
    if (props.ifon.outer_style) {
      src = props.ifon.imgeIfon.sns.cardAdvertising.path
      item = props.ifon.imgeIfon.sns.cardAdvertising
    } else {
      src = props.ifon.imgeIfon.sns.regularAdvertising.path
      item = props.ifon.imgeIfon.sns.regularAdvertising
    }
  } else {
    src = props.ifon.imgeIfon.gzh.path
    item = props.ifon.imgeIfon.gzh
  }

  return (<div className={`topImage ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`} style={src ? { height: item.zheight } : {}}>
    {src ? <div className='topImage_img'>
      <img className='img' src={src} />
    </div> : <div className='topImage_div1'>
      <i className='div1_icon'><svg width='80' height='54' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><g fill='none' fill-rule='evenodd'><path d='M19.5 6A2.5 2.5 0 0122 8.5v11a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 016 19.5v-11A2.5 2.5 0 018.5 6h11zm-2.657 8.156a1 1 0 00-1.347.006l-4.22 3.881a.5.5 0 01-.643.03l-2.731-2.087a.25.25 0 00-.402.199V19.5a1 1 0 001 1h11a1 1 0 001-1v-1.82a.5.5 0 00-.165-.371zM11 9.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z' fill='url(#a)' fill-rule='nonzero'></path><path d='M5.25 1a.75.75 0 010 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 010-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm5 0a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5z' fill='#C7C7C7'></path></g></svg></i>
      <button className='div_button' onMouseDown={(e) => {
        e.stopPropagation()
      }} onClick={() => {
        props.hoistPopup && props.hoistPopup()
      }}>上传图片</button>
    </div>}

  </div>)
}
